import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, switchMap, take } from 'rxjs';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '@content-platform/web-angular-shared-data-access-feature-flag-api';
import { TcpOktaService } from './tcp-okta.service';
import { OktaInterceptorApplications } from '../enums/okta-interceptor-applications.const';
import { ApplicationApiConstants } from '@content-platform/web-angular-shared-data-access-application-api';
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-data-access-feature-flag-api";
import * as i2 from "./tcp-okta.service";
export class OktaTokenInterceptor {
    constructor(featureFlagSvc, tcpOktaSvc) {
        this.featureFlagSvc = featureFlagSvc;
        this.tcpOktaSvc = tcpOktaSvc;
        this.addOktaToken = false;
        this.bAllowedOnlyForGO = false;
        this.bAllowedOnlyForC3 = false;
        this.authHeaderReady = new BehaviorSubject(undefined);
        // Okta is always enabled, so set auth header immediately
        this.setAuthHeader();
        this.checkTokenValidity();
        this.validUrls = ['api/status/', 'api/report/', 'api/reports/', 'api/schedule'];
        this.c3ValidUrls = [
            '/config',
            '/playlist',
            '/workflow',
            '/schedule/create',
            '/schedule/cancel',
            '/uwf/deliver'
        ];
        if (OktaInterceptorApplications.includes(ApplicationApiConstants.activeAppName) &&
            ApplicationApiConstants.activeAppName === 'C3 Linear Monitoring') {
            this.bAllowedOnlyForC3 = true;
        }
        // The `add-okta-token-to-http-header` flag is only defined in LaunchDarkly
        // for apps that actually opt into Okta token forwarding (currently C3 / GO).
        // Skipping the lookup elsewhere avoids the NOT_FOUND console.error from the
        // feature-flag service in apps that never use this flag (e.g. MIC).
        // Note: `appendAuthorizationToken` already short-circuits to `false` when
        // neither `bAllowedOnlyForC3` nor `bAllowedOnlyForGO` is true, so skipping
        // the subscription is functionally a no-op for those apps.
        if (this.bAllowedOnlyForC3 || this.bAllowedOnlyForGO) {
            this.featureFlagSvc.getFlagAsync('add-okta-token-to-http-header').subscribe((addOktaToken) => {
                this.addOktaToken = addOktaToken;
            });
        }
    }
    intercept(req, next) {
        if (this.appendAuthorizationToken(req.url)) {
            return this.authHeaderReady.pipe(filter((ready) => !!ready), switchMap(() => {
                req = req.clone({
                    setHeaders: {
                        authorization: `${this.authorizationHeader}`
                    }
                });
                return next.handle(req);
            }));
        }
        else {
            return next.handle(req);
        }
    }
    appendAuthorizationToken(reqUrl) {
        if (this.bAllowedOnlyForC3) {
            this.validUrls = this.c3ValidUrls;
        }
        if (this.addOktaToken && (this.bAllowedOnlyForC3 || this.bAllowedOnlyForGO)) {
            return this.validUrlCheck(this.validUrls, reqUrl);
        }
        return false;
    }
    validUrlCheck(allowedUrls, reqUrl) {
        return new RegExp('(' + allowedUrls.join('|') + ')').test(reqUrl);
    }
    getCurrentToken() {
        console.log('🚀🚀 -- getCurrentToken okta-token-interceptor');
        return this.tcpOktaSvc.getToken().pipe(take(1));
    }
    checkTokenValidity() {
        this.tcpOktaSvc.tokenRenewed().subscribe((newToken) => {
            console.log('🚀🚀 -- in checkTokenValidity() ->  tokenRenewed() subs');
            this.setAuthHeader(newToken);
        });
    }
    setAuthHeader(newToken) {
        this.getCurrentToken().subscribe((token) => {
            if (token && token?.accessToken) {
                // console.log('🚀🚀 -- setAuthHeader okta-token-interceptor token', token.accessToken);
            }
            else {
                // console.log('🚀🚀 -- setAuthHeader okta-token-interceptor newToken', newToken);
            }
            this.authorizationHeader = 'Bearer ' + (token?.accessToken ?? newToken);
            this.authHeaderReady.next(true);
        });
    }
    static { this.ɵfac = function OktaTokenInterceptor_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OktaTokenInterceptor)(i0.ɵɵinject(i1.WebAngularSharedDataAccessFeatureFlagApisService), i0.ɵɵinject(i2.TcpOktaService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OktaTokenInterceptor, factory: OktaTokenInterceptor.ɵfac, providedIn: 'root' }); }
}
//# sourceMappingURL=okta-token.interceptor.js.map